import { booleanAttribute, Component, HostBinding, Input } from '@angular/core';
import { isValidEnumValue, MuiColor } from '../utility';
import { FaFontWeight } from './fa-icon-font';
import { MuiIconFont } from './mui-icon-font';


@Component({
  selector: 'mui-icon, i[mui-icon]',
  exportAs: 'muiIcon',
  preserveWhitespaces: false,
  template: `
    @if (font === MuiIconFont.MIELE_PROGRAM_SYMBOLS) {
      <div [outerHTML]="name | muiProgramSymbol"></div>
    }
  `
})
export class MuiIcon {
  @Input() name = 'box';
  @Input() font: MuiIconFont | string = MuiIconFont.MIELE;
  @Input() color?: MuiColor | string;
  @Input({ transform: booleanAttribute }) spinning = false;
  @Input() iconStyle: FaFontWeight = FaFontWeight.LIGHT;
  @Input() class = '';

  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly MuiIconFont = MuiIconFont;

  @HostBinding('class')
  get iconConfigClass(): string {
    const classes = [
      this.class, // include original classes from the DOM element
      'mui-icon',
      this.getIconName(this.name),
      `${this.spinning ? 'spinning' : ''}`
    ];

    if (isValidEnumValue(MuiColor, this.color)) {
      classes.push(`mui-icon--${this.color}`);
    }

    return classes.join(' ');
  }

  @Input()
  @HostBinding('attr.role')
  role = 'presentation';

  @Input()
  @HostBinding('attr.aria-hidden')
  ariaHidden = true;

  convertWeight(weight: string): string {
    switch (weight) {
      case FaFontWeight.REGULAR:
      case 'regular':
      case 'far':
        return FaFontWeight.REGULAR;
      case FaFontWeight.THIN:
      case 'thin':
      case 'fat':
        return FaFontWeight.THIN;
      case FaFontWeight.SOLID:
      case 'solid':
      case 'fas':
        return FaFontWeight.SOLID;
      case 'light':
      case 'fal':
      default:
        return FaFontWeight.LIGHT;
    }
  }

  getIconName(n: string): string {
    switch (this.font) {
      case MuiIconFont.MIELE_PROGRAM_SYMBOLS:
        return 'mps';
      case MuiIconFont.FONTAWESOME:
        return `${this.convertWeight(this.iconStyle)} fa-${this.name}`;
      default:
        return `mi-${n}`;
    }
  }
}
